// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`IpAddressList Component should match snapshot 1`] = `
<ContextProvider
  value={
    {
      "canViewUnredactedImages": false,
      "email": "",
      "id": "",
      "isAdmin": false,
      "isSuperUser": false,
      "name": "",
      "roles": [
        "superuser",
      ],
    }
  }
>
  <ContextProvider
    value={[Function]}
  >
    <HeaderProvider>
      <IpAddressList />
    </HeaderProvider>
  </ContextProvider>
</ContextProvider>
`;
